import type { EmployeeOverview, UserActivityData } from "@/types";
import client from "./client";

interface TeamActivityResponse {
  date: string;
  employees: EmployeeOverview[];
}

export async function getEmployeesOverview(
  date: string,
): Promise<EmployeeOverview[]> {
  const params: Record<string, any> = { date };
  const { data } = await client.get<TeamActivityResponse>("/activity/team", {
    params,
  });
  return data.employees;
}

export async function getUserActivity(
  employeeId: number,
  date: string,
): Promise<UserActivityData> {
  const { data } = await client.get<UserActivityData>(
    `/activity/user/${employeeId}`,
    { params: { date } },
  );
  return data;
}
